import React from 'react';
import AppRoutes from './routes';
import GlobalStyles from './styles/GlobalStyles';


function App() {
    return (
        <>
            <GlobalStyles />
            <AppRoutes />
        </>
    );
}

export default App;